<div class="cald_dialog" #systemCertificateDataTableDialog>
  <div class="cald_header">
    <h2>{{'Admin.CertificateManagement.SelectCertificate'| translate}}</h2>
    <button type="button" class="close-dialog-button sap-icon" (click)="cancel()">&#xe03e;</button>
  </div>
  <div class="cald_content">
    <cpq-datatable [service]='service' [columns]="columns" (onRowsChanged)='onRowsChanged($event)'
    [filter]='filter' (onRowChanged)='onRowChanged($event)' [scrollbarH]="'true'"  [guid]="guid"></cpq-datatable>

    <ng-template #selectTmpl let-column="column" let-row='row'>
      <button type="button" class="fiori3-icon-button action-column-button" (click)="save(row)" title="{{'Admin.Msg.SelectButton' | translate}}">
        <span class="sap-icon">&#xe05b;</span>
      </button>
    </ng-template>
  </div>

  <div class="form-inline cald_dialog_buttonbar">
    @if (data && data.isMultiSelect) {
      <button type="button" class="btn btn-primary fiori3-btn-primary" tabindex="-1" (click)="save()">{{'Admin.Msg.Save' | translate}}</button>
    }
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" tabindex="-1" (click)="cancel()">{{'Msg.Cancel' | translate}}</button>
  </div>
</div>
